import { writable, get } from 'svelte/store';
import { onAuthStateChanged, signInWithPopup, OAuthProvider, signOut } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';
import { sessionStore, login, logout, updateRionBalance } from '../stores';
import { request } from './request';

export const loginGate = writable(null);
export const rewardNotice = writable('');
let pendingLogin = null;
const synchronizations = new Map();

export function requestLogin(reason = '계속하려면 로그인해 주세요.') {
  if (auth.currentUser && !auth.currentUser.isAnonymous && get(sessionStore).loggedIn) return Promise.resolve(true);
  if (pendingLogin) return pendingLogin.promise;
  let resolve;
  const promise = new Promise(done => { resolve = done; });
  pendingLogin = { promise, resolve };
  loginGate.set({ reason });
  return promise;
}
export function finishLogin(success) {
  pendingLogin?.resolve(success);
  pendingLogin = null;
  loginGate.set(null);
}

export async function refreshBalance() {
  const owner = get(sessionStore).userId;
  if (!get(sessionStore).loggedIn) return null;
  const data = await request('/api/coins/balance');
  if (get(sessionStore).userId === owner) updateRionBalance(data.total_rion ?? data.balance ?? 0);
  return data;
}
async function synchronizeUser(user) {
  if (synchronizations.has(user.uid)) return synchronizations.get(user.uid);
  const synchronization = (async () => {
    const idToken = await user.getIdToken();
    const data = await request('/api/firebase_login', { method: 'POST', authenticated: false, body: { id_token: idToken } });
    // Ignore a response from a previous identity after sign out/account switching.
    if (auth.currentUser?.uid !== user.uid) return;
    const previous = get(sessionStore);
    if (previous.userId && !previous.isGuest && String(previous.userId) !== String(data.user_id)) logout();
    login({ userId: data.user_id, name: data.name, email: data.email, photoURL: user.photoURL || '' });
    try {
      const reward = await request('/api/check_daily_reward', { method: 'POST', body: {} });
      if (reward.bonus_granted && auth.currentUser?.uid === user.uid) rewardNotice.set(`오늘 출석 보상 ${reward.reward_amount || 4} RION을 받았어요.`);
    } catch {}
    try { await refreshBalance(); } catch {}
    return data;
  })().finally(() => { synchronizations.delete(user.uid); });
  synchronizations.set(user.uid, synchronization);
  return synchronization;
}
export async function signIn(provider = 'google') {
  const selected = provider === 'apple' ? new OAuthProvider('apple.com') : googleProvider;
  if (provider === 'apple') { selected.addScope('email'); selected.addScope('name'); }
  const credential = await signInWithPopup(auth, selected);
  await synchronizeUser(credential.user);
  finishLogin(true);
}
export function watchAuthentication() {
  return onAuthStateChanged(auth, user => {
    if (!user || user.isAnonymous) {
      if (get(sessionStore).loggedIn) logout();
      return;
    }
    synchronizeUser(user).catch(error => {
      // Leave locally prepared images/options in place for a retry.
      if (auth.currentUser?.uid === user.uid) sessionStore.update(s => ({ ...s, loggedIn: false }));
      console.error('로그인 동기화 실패:', error);
    });
  });
}
export async function signOutSession() {
  await signOut(auth);
  logout();
  rewardNotice.set('');
  finishLogin(false);
}
